/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

*:focus {
  outline: none;
}

/* default */
:host {
  display: inline-block;
  vertical-align: middle;
  height: 3.2857142857rem;
  width: 100%;
  max-width: 41.1428571429rem;
  font-size: 1rem;
}
:host .container {
  height: 100%;
  text-decoration: none;
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}
:host .container .slotPlaceholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 1 auto;
}
:host .container .slotPlaceholder ::slotted(img) {
  height: 3.2857142857rem;
  width: auto;
  min-width: 3.2857142857rem;
}
:host .container .content {
  flex: 1 1 auto;
  padding: 0 1.4285714286rem;
}
:host .container .content .title {
  height: 1.5714285714rem;
  line-height: 1.5714285714rem;
  font-weight: bold;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}
:host .container .content .description {
  height: 0.8571428571rem;
  font-size: 0.8571428571rem;
  line-height: 0.8571428571rem;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .container .actionIcon {
  flex: 0 0 auto;
  min-width: 1.7142857143rem;
  padding: 0 1rem;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host .container .actionIcon davinci-icon,
:host .container .actionIcon davinci-icon-ref {
  font-size: 1rem;
}
:host .container:hover, :host .container:active {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .container {
  background-color: #FBFCFC;
  background-color: var(--davinci-color-background-2, #FBFCFC);
}
:host([disabled]) .container .slotPlaceholder ::slotted(img) {
  opacity: 0.5;
}
:host([disabled]) .container .content .title, :host([disabled]) .container .content .description {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container .actionIcon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
